import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "SoEz",
    "alternateName": ["SoEasy", "So Easy", "So Ez"],
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "operatingSystem": "Web",
    "description": "Enterprise-grade secure communication platform for businesses. Smart team messaging with AI integration, complete data control, and enterprise security.",
    "url": "https://soez.co.za",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "127"
    },
    "featureList": [
      "Secure Business Messaging",
      "AI-Powered Communication",
      "Enterprise Security",
      "Data Control",
      "Team Collaboration",
      "Smart Integrations"
    ]
  };

  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SoEz",
    "alternateName": ["SoEasy", "So Easy"],
    "url": "https://soez.co.za",
    "logo": "https://soez.co.za/logo.png",
    "description": "Enterprise communication platform provider",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "ZA"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "url": "https://soez.co.za"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
    </Helmet>
  );
};

export default SEO;
